import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-speaker",
  "use": "icon-speaker-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-speaker\" id=\"icon-speaker\"><rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\" /><circle cx=\"12\" cy=\"14\" r=\"4\" /><line x1=\"12\" y1=\"6\" x2=\"12.01\" y2=\"6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol